import IQueries from '@/interfaces/IQueries';

// Path with parameters
const landingRegions: IQueries = {
    landing_regions_list: {
        path: '/cloudflare/landing_regions',
        method: 'GET'
    }
};

export default landingRegions;
